import React from 'react';
import { TitleWrapper } from './Title.Styles';

export const Title = () => <TitleWrapper>Viva Modo Saudável</TitleWrapper>;